/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useRef, useState } from 'react'
import { Grid } from '@mui/material'
import { FnBlock_UI } from 'service/SystemFunction/SystemFunction';
import InnerHeadRoutes from 'components/Common/InnerHeadRoutes/InnerHeadRoutes';
import ManageAccountsIcon from '@mui/icons-material/ManageAccounts';
// yup
import * as yup from 'yup';
import { yupResolver } from '@hookform/resolvers/yup';
import { FormProvider, useForm } from 'react-hook-form';
import yupFormSchemas from 'components/Common/FormItem/yup/yupFormSchemas';

import { SnackbarCustom } from 'components/Common/Alert/Snackbars/Snackbar';
import { AxiosPost, AxiosPostFileExcel, Extension, ResultAPI } from 'service/CommonFunction/TS_function';
import UploadFile from 'components/Common/ElementInForm/UploadFile/UploadFile';
import { SwAlert } from 'components/Common/Alert/AlertForm';
import InputFormItem from 'components/Common/ElementInForm/InputFormItem';
import { BtnExportExcel } from 'components/Common/Button';
import moment from 'moment';



const MigrationDataUser = () => {

    const { BlockUI, UnBlockUI } = FnBlock_UI();

    const onClearImportFile = useRef(null);
    const [arrImport, setarrImport] = useState([] as any)
    //SnankBar
    const [IsOpenSnackbar, setIsOpenSnackbar] = useState(false)
    const [sSeveritySnackbar, setsSeveritySnackbar] = useState("success")
    const [sMessageSnackbar, setsMessageSnackbar] = useState(null) as any

    const [lstNotPass, setlstNotPass] = useState([])

    //#region  Form
    let objSchema = {
        SheetName: yupFormSchemas.string("Sheet Name", { required: false }),
    }

    const schema = yup.object().shape(objSchema);
    const form = useForm({
        resolver: yupResolver(schema),
        mode: 'all',
        shouldFocusError: true,
    })

    useEffect(() => {
        if (arrImport.length > 0) {
            onAddImportData();
        }
    }, [arrImport])

    const onAddImportData = () => {
        setlstNotPass([])
        let param = {
            sheetName: form.getValues("SheetName"),
            lstFile: arrImport,
        }

        BlockUI();
        AxiosPost("ImportData/MigrationDataUser", param, (res) => {
            UnBlockUI();
            ResultAPI(res, null, () => {
                onClearImportFile.current(null)
                setlstNotPass(res.lstDataNotPass)
                if (res.Message === "") {
                    setIsOpenSnackbar(true);
                    setsMessageSnackbar("นำเข้าข้อมูลสำเร็จ")
                    setsSeveritySnackbar("success")
                }
                else {
                    SwAlert.WarningScroll("แจ้งเตือน", res.Message, () => { });
                }
            })
        });
    }

    const ExportFile = () => {
        let Param = {
            lstDataNotPass : lstNotPass
        }
        let sFileName = `TrackMigration_${moment().format("DDMMYYYYHHmmss")}`;
        AxiosPostFileExcel(`Export/ExportMigration`, Param, sFileName, null, null, BlockUI, UnBlockUI)
    }



    return (
        <>
            <InnerHeadRoutes
                iconMUI={<ManageAccountsIcon style={{ fontSize: '1.5em' }} />}
                labal_Head="ผู้ดูแลระบบ"
                label_nameRoute="Migration Data User"
            />
            <Grid container spacing={2} direction="row" justifyContent="center" alignItems="center" style={{ marginTop: '0' }}>
                {lstNotPass.length > 0 && <Grid item xs={12}>
                    <BtnExportExcel
                        txt='Track Migration Error'
                        onClick={() => { ExportFile() }}
                    />
                </Grid>}
                <Grid item xs={12}>
                    <FormProvider {...form}>
                        <InputFormItem
                            id="SheetName"
                            name="SheetName"
                            label="Sheet Name"
                            required={false}
                            fullWidth
                        />
                    </FormProvider>
                </Grid>
                <Grid item >
                    <UploadFile
                        id="sFileImport"
                        keyID={1}
                        sTitle={"File Import"}
                        IsRequired={false}
                        arrFile={arrImport || []}
                        setarrFile={setarrImport}
                        IsFolder={false}
                        IsFile={true}
                        IsMultiple={false}
                        Extension={[...Extension.Excel]}
                        IsDrag={false}
                        nLimitFile={10}
                        sLimitFile={"MB"}
                        onClearFile={onClearImportFile}
                    />
                </Grid>
            </Grid>
            <SnackbarCustom
                IsOpen={IsOpenSnackbar}
                Severity={sSeveritySnackbar}
                OnClose={() => { setIsOpenSnackbar(false) }}
                Message={sMessageSnackbar}
            />
        </>
    )
}

export default MigrationDataUser